import { FlexRow } from '@/components/common/Flex';
import Modal from '@/components/common/modals/Modal';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { Goal } from '@common/goals';
import { toPx } from '@common/util/styles';
import { GoalCardStack } from '../../cardStack/GoalCardStack';
import { configByGoalType } from '../../config';
import { goalGuidanceCardHeight, goalGuidanceCardWidth } from '../../helpers';

export interface GoalOnboardingGuidanceModalProps {
    goal: Goal;
    onComplete: (goal: Goal) => void;
}

export const showGoalOnboardingGuidanceModal = (
    props: GoalOnboardingGuidanceModalProps
) => ModalManager.show(GoalOnboardingGuidanceModal, props);

const GoalOnboardingGuidanceModal =
    ModalManager.create<GoalOnboardingGuidanceModalProps>(
        ({ goal, onComplete }) => {
            useTrackModalShown('Goal Onboarding Guidance');

            const modal = useModal();

            return (
                <Modal
                    unstyled
                    isCentered
                    size="sm"
                    isOpen={modal.visible}
                    onClose={modal.remove}
                >
                    <FlexRow
                        minW={toPx(goalGuidanceCardWidth)}
                        w={toPx(goalGuidanceCardWidth)}
                        h={toPx(goalGuidanceCardHeight)}
                        p={0}
                    >
                        <GoalCardStack
                            goalId={goal.id}
                            config={configByGoalType[goal.type]}
                            goal={goal}
                            goalType={goal.type}
                            confirmationButtonText="Looks good"
                            onClose={() => modal.remove()}
                            onComplete={(goal) => {
                                onComplete(goal);
                                modal.remove();
                            }}
                        />
                    </FlexRow>
                </Modal>
            );
        }
    );

export default GoalOnboardingGuidanceModal;
